
import React, { useEffect, useState } from 'react';
import { Link, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBoxOpen,
    faCartShopping,
    faDollarSign,
    faClipboardList,
    faCubes,
    faObjectGroup,
    faCheckCircle
} from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next';




const SideBar = () => {
    const { t } = useTranslation();
    const { innerWidth: width, innerHeight: height } = window;
    //console.log('width::', width)
    const [collapseProduct, setCollapseProduct] = useState( width < 768 ? '' : 'show');

    useEffect(() => {

    }, [])

    const navClick = () => {

    }

    const activeMenuProduct = (isActive) => {
        if (isActive) {
            setCollapseProduct('show')
            return 'collapse-item active';
        } else {
            setCollapseProduct('')
            return 'collapse-item';
        }
    }

    //document.body.classList.add('modal-open');
    return (

        <ul className={`navbar-nav bg-gradient-success sidebar sidebar-dark accordion ${  width < 768 ? 'toggled' : '' }`} id="accordionSidebar">
            <a className="sidebar-brand d-flex align-items-center justify-content-center" href="#">
                <div className="sidebar-brand-text mx-3">GEC <sup>tm</sup></div>
            </a>
            <hr className="sidebar-divider my-0" />
            <li className="nav-item active">
                <Link to={`/`} className="nav-link">
                    <i className="fas fa-fw fa-tachometer-alt" />
                    <span>Dashboard</span>
                </Link>
            </li>
            <hr className="sidebar-divider" />
            <div className="sidebar-heading">
                Interface
            </div>
            <li className="nav-item">
                <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseProduct" aria-expanded="true" aria-controls="collapseTwo">
                    <FontAwesomeIcon icon={faCheckCircle} />
                    <span> {t('Approval')}</span>
                </a>
                <div id="collapseProduct" className={`collapse ${collapseProduct}`} aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                    <div className="bg-white py-2 collapse-inner rounded">
                        <h6 className="collapse-header">{t('Document approval')}:</h6>
                        <NavLink to={`/approval`} className="collapse-item">
                            <FontAwesomeIcon icon={faCubes} /> {t('Approv')}
                        </NavLink>
                        <NavLink to={`/approval/history`} className="collapse-item" >
                            <FontAwesomeIcon icon={faObjectGroup} /> {t('History')}
                        </NavLink>
                    </div>
                </div>
            </li>
             
            <div className="text-center d-none d-md-inline">
                <button className="rounded-circle border-0" id="sidebarToggle" onClick={navClick} />
            </div>

        </ul>

    )
}

export default SideBar; 